<section class="hero">
  <div class="hero-heading">
    <h1>
      <span class="word-manage">
        <svg class="spark" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="10" y1="0" x2="6" y2="12" stroke="#ff3b30" stroke-width="3" stroke-linecap="round" />
          <line x1="23" y1="4" x2="10" y2="17" stroke="#ff3b30" stroke-width="3" stroke-linecap="round" />
          <line x1="37" y1="11" x2="16" y2="21" stroke="#ff3b30" stroke-width="3" stroke-linecap="round" />
        </svg>
        Manage
      </span>
      Your Entire Business with a Powerful
      <br />
      <span class="accent">ERP</span> &amp; <span class="accent">POS</span> in One Platform
    </h1>
  </div>

  <div class="steps">
    <!-- Customer app -->
    <a class="step-card" [href]="customerUrl" target="_blank" rel="noopener">
      <div class="step-visual">
        <img class="step-img" src="/images/customer.png" alt="Customer app" />
      </div>
      <div class="step-label">Place your order</div>
    </a>

    <div class="connector connector-down">
      <svg class="connector-svg-desktop" viewBox="0 0 210 24">
        <path class="dash" d="M-60 21 Q105 -4 270 21" fill="none" />
        <circle class="dot dot-start" cx="0" cy="0" r="6" />
        <circle class="dot dot-end" cx="0" cy="0" r="6" />
        <circle class="dot-travel" cx="0" cy="0" r="5" />
      </svg>
      <svg class="connector-svg-compact" viewBox="0 0 28 20">
        <path class="dash-compact" d="M3 10 Q14 3 25 10" fill="none" />
        <circle class="dot-compact dot-start-compact" cx="0" cy="0" r="3.2" />
        <circle class="dot-compact dot-end-compact" cx="0" cy="0" r="3.2" />
        <circle class="dot-travel-compact" cx="0" cy="0" r="2.6" />
      </svg>
    </div>

    <!-- POS system -->
    <a
      class="step-card"
      [href]="partnerUrl"
      target="_blank"
      rel="noopener"
    >
      <div class="step-visual step-visual-pos">
        <img class="step-img step-img-pos" src="/images/pos-app.webp" alt="POS system" />
      </div>
      <div class="step-label">Create/manage your store</div>
    </a>

    <div class="connector connector-up">
      <svg class="connector-svg-desktop" viewBox="0 0 210 24">
        <path class="dash" d="M-60 21 Q105 -4 270 21" fill="none" />
        <circle class="dot dot-start" cx="0" cy="0" r="6" />
        <circle class="dot dot-end" cx="0" cy="0" r="6" />
        <circle class="dot-travel" cx="0" cy="0" r="5" />
      </svg>
      <svg class="connector-svg-compact" viewBox="0 0 28 20">
        <path class="dash-compact" d="M3 10 Q14 3 25 10" fill="none" />
        <circle class="dot-compact dot-start-compact" cx="0" cy="0" r="3.2" />
        <circle class="dot-compact dot-end-compact" cx="0" cy="0" r="3.2" />
        <circle class="dot-travel-compact" cx="0" cy="0" r="2.6" />
      </svg>
    </div>

    <!-- Rider app -->
    <a class="step-card" [href]="riderUrl" target="_blank" rel="noopener">
      <div class="step-visual">
        <img class="step-img" src="/images/rider1.png" alt="Rider app" />
      </div>
      <div class="step-label">Become a rider</div>
    </a>
  </div>
</section>

<app-about />

<app-customer />
<app-partners />
<app-rider />

<app-features />

<div class="section-divider">
  <span class="divider-line"></span>
  <span class="divider-mark">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="7" y1="16" x2="9" y2="8" stroke="#fff" stroke-width="2" stroke-linecap="round" />
      <line x1="13" y1="16" x2="15" y2="8" stroke="#fff" stroke-width="2" stroke-linecap="round" />
      <line x1="10" y1="16" x2="19" y2="8" stroke="#fff" stroke-width="2" stroke-linecap="round" />
    </svg>
  </span>
  <span class="divider-line"></span>
</div>

<app-erp />
<app-screens />
<app-faq />
<app-contact />
